module.exports = __webpack_public_path__ + "img/product-recovery-card-3d.ae0f3894.png";